import { DataBean } from "../DataBean";

export class CostingCenter extends DataBean {
  public async getCostingCenterCatalog(idCostingCenter: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getCostingCenterCatalog_Number",
      [idCostingCenter]
    );
  }

  public async updateCostingCenter(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.accountant.CostingCenter_updateCostingCenter_com.quickdataerp.bean.accountant.CostingCenter",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.quickdataerp.bean.accountant.CostingCenter",
        },
      ]
    );
  }
}
